import { render, staticRenderFns } from "./LoginError.vue?vue&type=template&id=16781ecf&"
import script from "./LoginError.vue?vue&type=script&lang=ts&"
export * from "./LoginError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16781ecf')) {
      api.createRecord('16781ecf', component.options)
    } else {
      api.reload('16781ecf', component.options)
    }
    module.hot.accept("./LoginError.vue?vue&type=template&id=16781ecf&", function () {
      api.rerender('16781ecf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoginError.vue"
export default component.exports